<div class="w-full py-3 px-2 sm:px-4">
  <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-4">
    <div class="flex flex-wrap items-center justify-start gap-1 lg:gap-2 mb-0">
      <!-- Back Button SVG (clickable) -->
    <svg class="size-6 cursor-pointer" [routerLink]="['/report/raw-metal']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
    
        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
            <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
    </svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/raw-metal/raw-metal.png" alt="Report" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Assembly Stock</span>
    </div>
    <div class="flex items-center justify-start gap-1 lg:gap-2">
      <svg *ngIf="titleTag" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-6">
        <mask id="mask0_848_1764" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"
          style="mask-type: alpha;">
          <rect width="24" height="24" fill="#C19725"></rect>
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725"></path>
        </g>
      </svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/stock/ready-product.png" alt="Stock"
        *ngIf="titleTag" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444" *ngIf="titleTag">Stock List</span>
    </div>
    <div class="w-full md:w-auto">
      <a routerLink="/product-creation"
        class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:bg-c19725 dark:hover:bg-[#fdffc6]">
        Add Assembly
      </a>
    </div>
  </div>

  <div class="flex flex-col lg:flex-row lg:flex-nowrap justify-between items-start lg:items-center gap-4">
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 items-center justify-center md:justify-start gap-3 w-full lg:w-auto">
      <div class="relative flex items-center gap-1 sm:gap-2">
        <label for="rowFilter" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Rows :
        </label>
        <select id="rowFilter" [(ngModel)]="itemsPerPage" (change)="filterTable()"
          class="w-full border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none !bg-none pr-6 focus:outline-none focus:ring-0 focus:border-c19725">
          <option *ngFor="let count of [5, 10, 20, 30, 40, 50, 100]" [value]="count">
            {{ count }}
          </option>
        </select>
        <div class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none">
          <svg width="10" height="5" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
          </svg>
        </div>
      </div>

      <div class="flex items-center gap-1 sm:gap-2">
        <label for="globalSearch" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Search :
        </label>
        <input id="globalSearch" type="text" [(ngModel)]="globalSearchText" (ngModelChange)="filterTable()"
          placeholder="Search all columns..."
          class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm w-full lg:w-64 focus:outline-none focus:ring-0 focus:border-c19725"
          autocomplete="off" />
      </div>
      <!-- ================= FROM DATE ================= -->
  <div class="flex items-center gap-1 sm:gap-2">
    <label
      for="startDate"
      class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
    >
      From :
    </label>

    <input
      id="startDate"
      type="date"
      [(ngModel)]="startDate"
      (change)="filterTable()"
      class="w-full border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm focus:outline-none focus:ring-0 focus:border-c19725"
    />
  </div>

  <!-- ================= TO DATE ================= -->
  <div class="flex items-center gap-1 sm:gap-2">
    <label
      for="endDate"
      class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
    >
      To :
    </label>

    <input
      id="endDate"
      type="date"
      [(ngModel)]="endDate"
      (change)="filterTable()"
      class="w-full border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm focus:outline-none focus:ring-0 focus:border-c19725"
    />
  </div>
    </div>

    <div class="flex items-center flex-wrap justify-center md:justify-end gap-2 w-full lg:w-auto">
      <button
        class="flex-1 md:flex-none text-[#F20707] border-1 border-[#F20707] bg-[#fff6f3] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadPDF()">
        PDF
      </button>
      <button
        class="flex-1 md:flex-none text-[#029921] border-1 border-[#029921] bg-[#e6ffe6] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadExcel()">
        Excel
      </button>
      <button
        class="flex-1 md:flex-none text-[#0720EC] border-1 border-[#0720EC] bg-[#E8E6FF] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadJSONAll()">
        JSON
      </button>
      <button
        class="flex-1 md:flex-none text-[#00ad94] border-1 border-[#00ad94] bg-[#e5fffb] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadCSV()">
        CSV
      </button>

      <div class="relative inline-block text-left flex-1 md:flex-none">
        <button (click)="toggleDropdown()"
          class="w-full text-[#B92185] border-1 border-[#B92185] bg-[#FFE1F5] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition">
          Visibility
        </button>

        <div *ngIf="showDropdown" class="absolute z-50 mt-2 p-4 bg-white border rounded shadow-2xl right-0 sm:-left-24 w-64">
          <p class="font-semibold mb-2">Select Columns to Show:</p>

          <label class="block text-sm mb-1">
            <input type="checkbox" [checked]="allFieldsSelected" (change)="selectAllFields()" autocomplete="off" />
            Select All
          </label>
          <label class="block text-sm mb-1">
            <input type="checkbox" [checked]="noFieldsSelected" (change)="deselectAllFields()" autocomplete="off" />
            Deselect All
          </label>
          <div class="mt-2 mb-2 border-t border-gray-200"></div>

          <div class="max-h-60 overflow-y-auto">
            <label *ngFor="let field of defaultFields" class="block text-sm mb-1">
              <input type="checkbox" [(ngModel)]="field.selected" (change)="onFieldToggle(field)" autocomplete="off" />
              {{ field.label }}
            </label>
          </div>

          <div class="mt-3 flex flex-col gap-2">
            <button (click)="restoreColumnSelection()" class="text-sm text-gray-600 hover:underline text-left">
              Restore Columns
            </button>

            <button (click)="applyColumnSelection()"
              class="mt-2 bg-blue-600 text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-blue-700 transition">
              Apply
            </button>
          </div>
        </div>
      </div>
      <button (click)="printTable()"
        class="flex-1 md:flex-none text-[#5606b6] border-1 border-[#5606b6] bg-[#ecddff] font-medium text-xs md:text-sm px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition">
        Print
      </button>
    </div>
  </div>

  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar border border-[#D9D9D9] rounded-md mt-6">
    <table
      class="w-full table border-collapse border-spacing-0 bg-white overflow-hidden">
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">
            No.
          </th>
          <th *ngFor="let field of selectedFieldss" [hidden]="!field.selected"
            class="p-2 font-medium text-left border-r border-444 last:border-r-0">
            <div class="flex flex-col gap-1 w-32 sm:w-40 lg:w-48">
              <input type="text" [(ngModel)]="searchValues[field.key]" (click)="$event.stopPropagation()"
                (ngModelChange)="filterTable()" [attr.placeholder]="'Search ' + field.label"
                class="border border-dcdcdc p-1 rounded-[5px] text-xs w-full focus:border-c19725 outline-none font-normal" autocomplete="off" />

              <div class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer select-none"
                (click)="sortBy(field.key)">
                {{ field.label }}
                <svg *ngIf="sortKey === field.key" class="w-3 h-3" viewBox="0 0 24 24">
                  <path *ngIf="sortDirection === 'asc'" d="M12 8l6 6H6z" fill="currentColor" />
                  <path *ngIf="sortDirection === 'desc'" d="M12 16l-6-6h12z" fill="currentColor" />
                </svg>
              </div>
            </div>
          </th>

          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">
            Action
          </th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm lg:text-base">
        <tr *ngIf="paginatedStockList.length === 0">
          <td [attr.colspan]="selectedFieldss.length + 2" class="p-4 text-center text-gray-500">
            No stock entries found.
          </td>
        </tr>
        <tr *ngFor="let item of paginatedStockList; let i = index" class="hover:bg-gray-50">
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
            {{ (currentPage - 1) * itemsPerPage + i + 1 }}
          </td>

          <ng-container *ngFor="let field of selectedFieldss">
            <td *ngIf="field.selected" class="p-2 border-r border-b border-[#D9D9D9]">
              <ng-container *ngIf="field.isImage; else textField">
                <div class="flex justify-center items-center">
                <img [src]="proxyImageUrl(item[field.key]) || '/assets/images/no-image.png'"
                    class="w-12 h-12 object-contain rounded border" />
                </div>
              </ng-container>
              <ng-template #textField>
                {{ field.key === 'st_item_category' ? item.st_item_category?.name : getDisplayValue(item[field.key]) }}
              </ng-template>
            </td>

          </ng-container>

          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
            <div class="flex items-center justify-center gap-1 sm:gap-2">
              <button 
                *ngIf="item.st_distribution === 'retail'"
                (click)="openRetailModal(item)" 
                class="bg-blue-600 text-white text-[10px] sm:text-xs font-semibold px-2 py-1 rounded-md hover:bg-blue-700 transition shadow-sm">
                Retail
              </button>
            </div>
          </td>
        </tr>
      </tbody>

    </table>
  </div>
  <div class="flex flex-col sm:flex-row items-center justify-between border-t border-gray-200 bg-white py-3 gap-4">
    <div class="text-xs text-gray-500">
      Page {{currentPage}} of {{totalPages}}
    </div>
    <div class="flex sm:flex-1 sm:items-center sm:justify-end">
      <div>
        <nav class="isolate inline-flex gap-1 md:gap-2 -space-x-px rounded-md shadow-xs" aria-label="Pagination">
          <button (click)="goToPreviousPage()" [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:pointer-events-none">
            <span class="sr-only">Previous</span>
            <svg class="size-5 md:size-6" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path fill-rule="evenodd"
                d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd" />
            </svg>
          </button>
          
          <div class="flex gap-1 overflow-x-auto max-w-[150px] sm:max-w-none no-scrollbar">
            <ng-container *ngFor="let page of pageNumbers">
              <ng-container *ngIf="page !== -1; else ellipsis">
                <button (click)="goToPage(page)" [class.bg-c19725]="currentPage === page"
                  [class.text-white]="currentPage === page"
                  class="relative z-10 inline-flex items-center justify-center min-w-[32px] md:min-w-[36px] h-8 md:h-9 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c19725">
                  {{ page }}
                </button>
              </ng-container>
              <ng-template #ellipsis>
                <span
                  class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-sm font-normal text-gray-700 focus:outline-offset-0">...</span>
              </ng-template>
            </ng-container>
          </div>

          <button (click)="goToNextPage()" [disabled]="currentPage === totalPages"
            class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:pointer-events-none">
            <span class="sr-only">Next</span>
            <svg class="size-5 md:size-6" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd" />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Retail Modal Overlay - UPDATED WIDTH -->
<div *ngIf="isRetailModalOpen" class="fixed inset-0 z-[100] flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none p-2 sm:p-4">
  <div class="fixed inset-0 bg-black opacity-60 backdrop-blur-sm" (click)="closeRetailModal()"></div>
  
  <div class="relative w-full max-w-[95vw] sm:max-w-4xl lg:max-w-8xl mx-auto my-6 z-[101]">
    <div class="relative flex flex-col w-full bg-white border-0 rounded-xl shadow-2xl outline-none focus:outline-none max-h-[90vh]">
      
      <!-- Modal Header -->
      <div class="flex items-center justify-between p-3 sm:p-4 border-b bg-gray-50 rounded-t-xl">
        <div class="flex items-center gap-2">
            <span class="size-2 sm:size-3 bg-c19725 rounded-full"></span>
            <h3 class="text-base sm:text-xl font-bold text-gray-800">Retail Details for: <span class="text-c19725">{{selectedStockItem?.st_item_code}}</span></h3>
        </div>
        <button class="text-gray-400 hover:text-red-500 transition-colors text-2xl sm:text-3xl font-semibold leading-none" (click)="closeRetailModal()">×</button>
      </div>

      <!-- Modal Body -->
      <div class="relative p-2 sm:p-4 flex-auto overflow-y-auto">
        <app-retail-stock [itemCode]="selectedStockItem?.st_item_code"></app-retail-stock>
      </div>

      <!-- Modal Footer -->
      <div class="flex items-center justify-end p-3 border-t bg-gray-50 rounded-b-xl">
        <button class="bg-gray-800 text-white font-semibold text-xs sm:text-sm px-4 sm:px-6 py-2 rounded hover:bg-black transition shadow-sm" (click)="closeRetailModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>